/**
 * @file: 统计数据展示组件
 */

import React from 'react';
import { Divider, Statistic } from 'antd';

import './statistic.less';

const StatisticCard = ({ data }) => (
  <div className="statistic-wrapper">
    {data.map((item, index) => (
      <div className="statistic-item" key={item.value}>
        <div className="flex">
          <Statistic title={item.title} value={item.value} />
          {index < data.length - 1 ? <Divider type="verticle" style={{ height: '60px' }} /> : null}
        </div>
      </div>
    ))}
  </div>
);
export default StatisticCard;



// WEBPACK FOOTER //
// ./src/components/comm/statistic/Index.js